/**
 * Login screen with passphrase input.
 * JWT is stored in memory only (not localStorage/sessionStorage).
 */

import { useState, type FormEvent } from 'react';
import { useAuthStore } from '../store/auth';
import { getApiBase } from '../api/client';

export function LoginView() {
  const [passphrase, setPassphrase] = useState('');
  const { login, isLoading, error, clearError } = useAuthStore();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!passphrase.trim()) return;
    await login(passphrase, getApiBase());
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen px-4"
      style={{ backgroundColor: 'var(--bg-primary)' }}
    >
      <div
        className="w-full max-w-sm p-8 rounded-xl"
        style={{
          backgroundColor: 'var(--bg-secondary)',
          border: '1px solid var(--border-color)',
        }}
      >
        <div className="text-center mb-8">
          <h1
            className="text-2xl font-bold mb-1"
            style={{ color: 'var(--accent)' }}
          >
            AnnaCalendar
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
            Enter your passphrase to continue
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="passphrase" className="sr-only">
              Passphrase
            </label>
            <input
              id="passphrase"
              type="password"
              value={passphrase}
              onChange={(e) => {
                setPassphrase(e.target.value);
                if (error) clearError();
              }}
              placeholder="Passphrase"
              className="w-full px-4 py-3 rounded-lg text-base outline-none transition-colors"
              style={{
                backgroundColor: 'var(--bg-tertiary)',
                color: 'var(--text-primary)',
                border: `1px solid ${error ? 'var(--danger)' : 'var(--border-color)'}`,
              }}
              disabled={isLoading}
              autoFocus
              autoComplete="current-password"
            />
          </div>

          {error && (
            <p className="text-sm text-center" style={{ color: 'var(--danger)' }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={isLoading || !passphrase.trim()}
            className="w-full py-3 rounded-lg text-base font-semibold transition-opacity"
            style={{
              backgroundColor: 'var(--accent)',
              color: '#fff',
              opacity: isLoading || !passphrase.trim() ? 0.5 : 1,
            }}
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
